import DefaultMap from "./DefaultMap";

export default DefaultMap;
